<template>
  <div class="sb_icon">
    <svg role="img">
      <use :xlink:href="`#icon_${icon}`" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    icon: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .sb_icon {
    display: flex;
    flex-direction: column;
    justify-content: center;
    > svg {
      width: 1em;
      height: 1em;
      fill: currentColor;
    }
  }
}
</style>
